import { render, staticRenderFns } from "./DevolucionesNewFormComponent.vue?vue&type=template&id=712b2bc4&"
import script from "./DevolucionesNewFormComponent.vue?vue&type=script&lang=js&"
export * from "./DevolucionesNewFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./DevolucionesNewFormComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports